module.exports = __webpack_public_path__ + "media/m5.bc0a435f.mp4";